'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minutesBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/minutesBefore.js
// module id = 711
// module chunks = 0